<script>
import appConfig from '@src/app.config.json'
import Layout from '@layouts/user-management.vue'
import FigmentsManagementTable from '@components/tables/figments-management-table.vue'
import { httpServices } from '@utils/http-services'

export default {
  page: {
    title: 'Figments',
    meta: [{ name: 'description', content: appConfig.description }],
  },
  components: { Layout, FigmentsManagementTable },
  data() {
    return {
      figments: null,
      groups: null,
      showAll: this.$auth.user.profile.permissions.organization === 'vanished',
    }
  },
  async mounted() {
    this.figments = await httpServices.getFigments()
    this.groups = await httpServices.getGroups()
  },
  methods: {
    onDeleteFigment(record) {
      const id = record.pk.replace('FIGMENT#', '')
      httpServices.deleteFigment(id, record.orgId).then(
        (_r) => {
          this.$notification.success({
            message: `Figment Deleted`,
          })
          this.$router.go(0)
        },
        () => {
          this.$notification.error({
            message: `Failed to Delete`,
          })
        }
      )
    },
    createFigment() {
      this.$router.push({
        name: 'create-figment',
      })
    },
  },
}
</script>

<template>
  <Layout>
    <div id="figments--container" class="ant-row">
      <div class="header">
        <h4>
          <a-icon type="solution" style="padding-right: 8px" />
          Figments
        </h4>
        <a-button type="ghost" icon="plus-circle" @click="createFigment"
          >Add New</a-button
        >
      </div>
      <a-card style="width: 100%; margin-top: 0">
        <div v-if="!figments || !groups" class="loader--container">
          <a-icon
            type="loading"
            style="padding-left: 8px; font-size: 24px; color: #1890ff"
            spin
          />
        </div>
        <div v-else>
          <FigmentsManagementTable
            :groups="groups"
            :figments="figments"
            @deleteFigment="onDeleteFigment"
          ></FigmentsManagementTable>
        </div>
      </a-card>
    </div>
  </Layout>
</template>

<style lang="scss">
@import '@design';

#figments--container {
  position: relative;
  width: 100%;
  padding: 16px;
  margin: 0 0 16px;
  background: white;
  border: 1px solid #ebedf0;
  box-shadow: 4px 8px 24px 5px rgb(208 216 243 / 60%);
  transition: all 0.2s;

  .header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 1.2rem;
    margin-bottom: 0;
    text-align: left;
    background: #141414;
    border-radius: 4px 4px 0 0;

    h4 {
      margin: 0;
      font-weight: 100;
      color: white;
    }
  }

  .ant-card {
    margin: 1.6rem auto;

    .ant-card-head-title {
      font-weight: 700;
    }
  }

  table tr td {
    text-transform: capitalize;
  }
}
</style>
